import type { Middleware, RequestContext } from "core/api/coreApiClient";
import queryString from "query-string";

const maxRetry = 2;

class RetryMiddleware implements Middleware {
  retryNumber?: number;

  retryOnFailure?: boolean;

  pre = async (context: RequestContext) => {
    // Retry to fetch data as the API call might drop randomly (only active when retryNumber is set via fetchWithRetry)
    if (this.retryNumber !== undefined) {
      const query: { retry?: string; retryOnFailure?: string } = {};
      if (this.retryNumber > 0) query.retry = this.retryNumber.toString();
      if (this.retryNumber < maxRetry) {
        this.retryOnFailure = true;
        query.retryOnFailure = this.retryOnFailure.toString();
      } else {
        this.retryOnFailure = false;
      }

      context.url = queryString.stringifyUrl({ url: context.url, query });
    }

    return Promise.resolve(context);
  };
}

export default RetryMiddleware;
